import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Navbar from '../NavBar/Navbar';
import MapDashboard from '../myproporties/MapDashboard';
import FadeLoader from "react-spinners/FadeLoader";
import PropertyList from './PropertyList'
const PendingApprovals = () => {
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const [parkingLotBookingDetails, setParkingLotBookingDetails] = useState([]);
    const [filter, setFilter] = useState([]);
    const [search, setSearch] = useState("");
    const [open, setOpen] = React.useState(false);
    const [userData, setUserdata] = useState();
    const [rowData] = useState([]);
    const [areasmarked] = useState([]);
    const [isEdit] = useState();
    const [parkinglotObj] = useState();
    const [defaultaddress] = useState();
    const [loader, setLoader] = useState(false);
    const [selectedStatus] = useState(''); // This will store the selected status
    const [isSalespersonloggedin] = useState(true);
    const [myworklistredirect] = useState(true);
    
    // Function to handle status change from StatusDropdown   
       

    function getLoggedInUser() {
        const loggedInUser = localStorage.getItem('LogedInUser');
        if (!loggedInUser) {
            console.error('No LoggedInUser found');
            return null;
        }
        try {
            const stateLoggedInUser = JSON.parse(loggedInUser);
            return stateLoggedInUser;
        } catch (error) {
            console.error('Error parsing LoggedInUser', error);
            return null;
        }
    }
    const stateLogedInUser = getLoggedInUser();

    useEffect(() => {
        const fetchParkinglotDetails = async () => {
            setLoader(true);
            try {
                const response = await fetch(`${hostPath}/api/GetAllParkingLots?status=Submitted`, {
                    method: 'GET',
                    headers: { "x-functions-key": `${hostHeader}` },
                });
                setLoader(false);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setParkingLotBookingDetails(data);
            } catch (error) {
                setLoader(false);
                console.error('Failed to fetch user details:', error);
            }
        };

        fetchParkinglotDetails();
    }, [hostPath, userData]); // Add stateLogedInUser to the dependency array
    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const response = await fetch(`${hostPath}/api/GetUserDetailsbyid`, {
                    method: 'POST',
                    headers: { "x-functions-key": `${hostHeader}` },
                    body: JSON.stringify({ EntityRegistrationID: stateLogedInUser }),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                setUserdata(data[0])
            } catch (error) {
                console.error('Failed to fetch user details:', error);
            }
        };

        fetchUserDetails();
    }, [stateLogedInUser]);
    useEffect(() => {
        let result = parkingLotBookingDetails;

        // Filter by search query
        if (search) {
            result = result.filter((item) => {
                return (item.parkingLotAddress || item.createdDate).toLowerCase().includes(search.toLowerCase());
            });
        }

        // Filter by selected status
        if (selectedStatus.length > 0) {
            result = result.filter((item) => selectedStatus.includes(item.status));
        }

        setFilter(result);
    }, [search, parkingLotBookingDetails, selectedStatus]);
   
    const handleConfirm = (text) => {
        if (text === 'confirm') {
            const requestOptions = {
                method: 'POST',
                headers: { "x-functions-key": hostHeader },
                body: JSON.stringify(rowData)
            };
            axios.post(`${hostPath}/api/DeleteParkingLotDetailsByEmailId`, requestOptions.body, { headers: requestOptions.headers })
                .then(response => {
                    if (response.data) {
                        if (response.data.status) {
                            const newdata = parkingLotBookingDetails.filter((item) => item.parking_Lot_ID !== rowData.Parking_Lot_ID);
                            setParkingLotBookingDetails(newdata);
                            setFilter(newdata);
                            setOpen(false);
                        }
                        else {
                            alert(response.data.responseMessage);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }
        else if (text === 'cancel') {
            setOpen(false);
        }
    };
 

    return (
        <div>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}
            <Navbar userData={userData} />

            {!isEdit ? (
                <div>
                    <div className='container-fluid p-0'>
                        <div className="lotmanagements">
                            <div className="row" style={{ textAlign: "left" }}>
                                <div className="col-8">
                                    <div className='viewHeader'>Registered Parking Lots</div>
                                </div>
                                <div className="col-4">
                                    <input type='text' className="form-control" placeholder='Search by address.' onChange={(e) => setSearch(e.target.value)} />
                                </div>
                            </div>
                            <div className="row" style={{ textAlign: "left" }}>
                                <div className="col-12 mb-2">
                                    Total parking lots: {parkingLotBookingDetails.length}
                                </div>
                            </div>
                            
                        </div>

                        <PropertyList filter={filter} />
                    </div>
                    <Dialog
                        classes={{ paper: 'custom-paper-class-delete' }}
                        aria-labelledby="customized-dialog-title"
                        dividers
                        open={open}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <DialogTitle dividers sx={{ textAlign: 'start', color: "#000;", fontSize: "24px", fontWeight: "700", padding: "5px 24px " }} id="customized-dialog-title">
                            Are you Sure You Want to Delete This Property?
                        </DialogTitle>
                        <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000;" }}>
                            <Typography gutterBottom>
                                <span>Once you delete this property, you will not be able to retrieve the data. This action is irreversible. Please confirm if you wish to proceed.</span>
                            </Typography>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'right' }}>
                            <Button
                                className='custom-button-cancel'
                                onClick={() => handleConfirm('cancel')}
                            >
                                Cancel
                            </Button>
                            <Button
                                className='custom-button-delete'
                                onClick={() => handleConfirm('confirm')}
                            >
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>

                </div>
            ) : (
                <div><MapDashboard isEdit={isEdit} areasMarked={areasmarked} defaultaddress={defaultaddress} parkinglotObj={parkinglotObj} isSalespersonloggedin={isSalespersonloggedin} myworklistredirect={myworklistredirect} /></div>
            )}
        </div>

    );
};

export default PendingApprovals;
